export default {
    baseStyle: {
        // Layout
        container: {
            maxWidth: {base: '100%', lg: '1120px'},
            py: {base: 7, lg: 16},
            px: {base: 4, lg: 5}
        },
        progress: {
            marginBottom: {base: '37px', lg: '30px'}
        },
        headerSection: {
            spacing: '15px'
        },
        headerStack: {
            textAlign: 'center',
            marginX: 'auto'
        },
        grid: {
            columns: {base: 1, lg: 2},
            spacing: {base: 10, lg: 16},
            marginTop: '30px',
            alignItems: 'start'
        },
        rightColumn: {
            spacing: '35px'
        },
        continueWrapper: {
            justify: 'center',
            marginTop: {base: 12, lg: 16}
        },
        continueButton: {
            width: 'full',
            maxWidth: '255px',
            minWidth: 'auto'
        },

        // Header copy
        orderNumber: {
            fontFamily: 'body',
            fontWeight: '400',
            fontSize: '15px',
            color: '#000',
            lineHeight: '20px',
            letterSpacing: '0.8px'
        },
        thankYou: {
            fontFamily: 'cormorant',
            fontWeight: '400',
            fontSize: '25px',
            color: '#000',
            lineHeight: '35px',
            letterSpacing: '0.495px'
        },
        helpText: {
            fontFamily: 'body',
            fontWeight: '300',
            fontSize: '16px',
            color: '#000',
            lineHeight: '25px',
            letterSpacing: '0.5px',
            sx: {
                b: {
                    fontWeight: '400'
                }
            }
        },

        // Guest signup block
        guestBox: {
            maxWidth: '720px',
            marginX: 'auto',
            marginTop: 10
        },

        // Receipt
        receiptHeaderRow: {
            justify: 'space-between',
            align: 'baseline'
        },
        receiptHeading: {
            fontFamily: 'body',
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '25px',
            letterSpacing: '0.005em',
            color: '#000'
        },
        printButton: {
            fontFamily: 'body',
            fontWeight: '400',
            fontSize: '15px',
            lineHeight: '20px',
            letterSpacing: '0.5px',
            color: '#000'
        },
        sectionDivider: {
            borderColor: 'gray.550',
            marginTop: '13px',
            marginBottom: '13px'
        },
        receiptTotals: {
            spacing: 2
        },
        receiptRow: {
            fontFamily: 'body',
            fontWeight: '300',
            fontSize: '15px',
            lineHeight: '20px',
            letterSpacing: '0.5px',
            color: '#000'
        },
        receiptRowTotal: {
            fontFamily: 'body',
            fontWeight: '400',
            fontSize: '15px',
            lineHeight: '20px',
            letterSpacing: '0.5px',
            color: '#000'
        },
        discountAmount: {
            color: 'green.500'
        },

        // Line items
        lineItem: {
            alignItems: 'flex-start',
            gap: '20px',
            paddingTop: '50px',
            paddingBottom: '50px',
            borderBottom: '1px solid',
            borderColor: 'gray.550',
            _last: {
                borderBottomWidth: {base: 0, lg: '1px'}
            }
        },
        lineItemImage: {
            flexShrink: 0,
            '.image-box': {
                width: '120px',
                height: '150px',
                minWidth: '120px',
                minHeight: '150px',
                backgroundColor: 'gray.100'
            },
            '.product-image': {
                width: '120px',
                height: '150px',
                objectFit: 'contain',
                mixBlendMode: 'multiply'
            }
        },
        lineItemContent: {
            spacing: '10px',
            flex: 1
        },
        productName: {
            fontFamily: 'heading',
            fontWeight: 400,
            fontSize: '18px',
            lineHeight: 1,
            letterSpacing: '0.005em',
            color: 'black.100'
        },
        productAttributes: {
            fontFamily: 'body',
            fontWeight: 300,
            fontSize: '14px',
            lineHeight: '22px',
            letterSpacing: '0.005em',
            color: 'black.100'
        },
        productPrice: {
            fontFamily: 'body',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '22px',
            letterSpacing: '0.005em',
            color: 'black.100'
        },

        // eGift card line item
        egiftRow: {
            justify: 'space-between',
            align: 'flex-start',
            gap: '20px',
            paddingTop: '50px',
            paddingBottom: '50px',
            borderBottom: '1px solid',
            borderColor: 'gray.550',
            _last: {
                borderBottomWidth: {base: 0, lg: '1px'}
            }
        },
        egiftName: {
            fontFamily: 'heading',
            fontWeight: '400',
            fontSize: '18px',
            lineHeight: '1',
            letterSpacing: '0.005em',
            color: 'black.100'
        },
        egiftRecipient: {
            fontFamily: 'body',
            fontWeight: '300',
            fontSize: '14px',
            lineHeight: '22px',
            letterSpacing: '0.005em',
            color: 'black.100',
            marginTop: '10px'
        },
        egiftAmount: {
            fontFamily: 'body',
            fontWeight: '400',
            fontSize: '14px',
            lineHeight: '22px',
            letterSpacing: '0.005em',
            color: 'black.100'
        },

        // Right-column sections (Shipping / Payment / Gift Message)
        sectionHeading: {
            fontFamily: 'body',
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '25px',
            letterSpacing: '0.005em',
            color: '#000'
        },
        sectionStack: {
            spacing: '12px'
        },
        detailText: {
            fontFamily: 'body',
            fontWeight: '300',
            fontSize: '16px',
            lineHeight: '25px',
            letterSpacing: '0.5px',
            color: '#000'
        },
        addressText: {
            fontFamily: 'body',
            fontWeight: '300',
            fontSize: '16px',
            lineHeight: '25px',
            letterSpacing: '0.005em',
            color: '#000'
        },

        // Error / fallback state
        fallbackStack: {
            spacing: 4,
            textAlign: 'center',
            maxWidth: '640px',
            marginX: 'auto'
        },
        fallbackOrderNumber: {
            fontSize: '16px',
            fontWeight: '600'
        },
        fallbackHeading: {
            fontFamily: 'heading',
            fontSize: {base: '28px', lg: '36px'}
        },
        fallbackText: {
            fontSize: '16px',
            color: 'black.100'
        },
        fallbackButtonWrapper: {
            justify: 'center',
            pt: 2
        }
    }
}
